import { Component, OnInit } from '@angular/core';
import { SubheaderService } from '../../../../../core/services/layout/subheader.service';
import { MensagensService } from 'max-ng-lib';
import { enumTipoEmail } from '../../../../../core/enums/enums';
import { ValidacaoHelper } from '../../../../../../utils/validacao-helper';
import { ConfiguracaoEmailService } from '../../../../../services/configuracao-email.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'm-configuracao-conta-email',
  templateUrl: './configuracao-conta-email.component.html',
  styleUrls: ['./configuracao-conta-email.component.scss'],
})
export class ConfiguracaoContaEmailComponent implements OnInit {

  modelo: any = {};
  tipos = enumTipoEmail;
  validador: ValidacaoHelper;
  carregou = false;
  formControl: FormControl = new FormControl();

  constructor(
    public subheaderService: SubheaderService,
    public mensagem: MensagensService,
    public configuracaoEmailService: ConfiguracaoEmailService) {

    this.validador = new ValidacaoHelper(mensagem);

    this.consultarConfiguracaoEmail();
  }

  private consultarConfiguracaoEmail() {
    this.configuracaoEmailService
      .consultarConfiguracaoEmail()
      .subscribe(modelo => {
        this.modelo = modelo;
        this.modelo.autenticacaoSMTP = !!this.modelo.autenticacaoSMTP;
        this.modelo.ativarTSL = !!this.modelo.ativarTSL;
        this.modelo.envioHabilitado = !!this.modelo.envioHabilitado;
        this.modelo.envioTimeline = !!this.modelo.envioTimeline;
        this.carregou = true;
      });
  }

  ngOnInit() {

    this.subheaderService.setTitle('Configurações de e-mail');
    this.subheaderService.setBreadcrumbs([
      { title: 'Configurações de e-mail', page: 'configuracoes/configuracao-email' },
    ]);
  }

  podeGravar = () => {

    if (!this.modelo.host) {
      this.validador.setFocoNoElementoDaClasseEExibeMensagem('host', 'O Host é obrigatório!');
      return false;
    }

    if (!this.modelo.porta) {
      this.validador.setFocoNoElementoDaClasseEExibeMensagem('porta', 'A Porta é obrigatória!');
      return false;
    }

    if (!this.modelo.usuario) {
      this.validador.setFocoNoElementoDaClasseEExibeMensagem('usuario', 'O Usuário é obrigatório!');
      return false;
    }

    if (!this.modelo.senha) {
      this.validador.setFocoNoElementoDaClasseEExibeMensagem('senha', 'A Senha é obrigatória!');
      return false;
    }

    if (!this.modelo.remetente) {
      this.validador.setFocoNoElementoDaClasseEExibeMensagem('remetente', 'O Remetente é obrigatório!');
      return false;
    }

    if (!this.modelo.campoERP) {
      this.validador.setFocoNoElementoDaClasseEExibeMensagem('campoERP', 'O Campo E-mail ERP é obrigatório!');
      return false;
    }

    if (!this.modelo.empresa) {
      this.validador.setFocoNoElementoDaClasseEExibeMensagem('empresa', 'A Empresa é obrigatória!');
      return false;
    }

    return true;
  }

  verificarEmail() {
    this.configuracaoEmailService.verificarConfiguracoes(this.modelo)
      .subscribe((result: string) => {
        this.mensagem.exibaToastSucesso(result);
      });
  }
}
